import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';

export function sendAgreement(
    applicationId: number | string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> {
    return client.post<{ msg: string }>(
        `/send-agreement/${applicationId}`,
        undefined,
        customConfig
    );
}
